// extracted by mini-css-extract-plugin
module.exports = {"close-button":"CloseButton_close-button__OK97H"};